import PlansPanel from "./PlansPanel";

function Plan(block) {
  const { data } = block;
  return (
    <PlansPanel data={data} />
  );
}

export default Plan;
